// Copyright (c) 2026 AesirX.io Ltd. All rights reserved.
// This source code is proprietary and confidential.
// See LICENSE.md for licensing terms.
import { z } from 'zod';
import { EmailSchema, PhoneSchema, NameSchema } from './common.js';
export const LoginSchema = z.object({
    email: EmailSchema,
    password: z.string().min(1, 'Password is required'),
});
export const CreateUserSchema = z.object({
    name: NameSchema,
    email: EmailSchema,
    password: z.string().min(8, 'Password must be at least 8 characters').max(128),
    phone: PhoneSchema,
    identity_type: z.enum(['local', 'sso']).default('local'),
    initial_role_id: z.string().optional(),
});
export const UpdateUserSchema = z
    .object({
    name: NameSchema.optional(),
    email: EmailSchema.optional(),
    phone: PhoneSchema,
    status: z.enum(['active', 'inactive', 'suspended']).optional(),
})
    .refine((data) => Object.keys(data).length > 0, { message: 'At least one field required' });
export const ChangePasswordSchema = z.object({
    current_password: z.string().min(1),
    new_password: z.string().min(8).max(128),
});
//# sourceMappingURL=user.js.map